export default {"src":"/_next/static/media/marker_filled.9db0b9bb.svg","height":24,"width":24};